import React, { FC, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { get_niveles_tp } from "../services/api";
import SpinnerUmmIA from "../components/Loading/SpinnerUmmIA";

export interface FormattedNivelTP {
  id: string;
  nombre: string;
}

interface Props {
  especialidadId: string;       
  selectedNivelId: string;
  onNivelChange: (nivel: FormattedNivelTP) => void;
  disabled?: boolean;
}

const GetNivelesTP: FC<Props> = ({
  especialidadId,
  selectedNivelId,
  onNivelChange,
  disabled = false,
}) => {
  const [data, setData] = useState<FormattedNivelTP[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNiveles = async () => {
      if (!especialidadId) {
        setData([]);
        return;
      }

      setLoading(true);
      try {
        const resp = await get_niveles_tp(especialidadId);

        if (!resp || resp.status !== 200) {
          console.error("get_niveles_tp: respuesta inválida", resp);
          setData([]);
          return;
        }

        const raw = Array.isArray(resp.data?.data) ? resp.data.data : [];
        const niveles: FormattedNivelTP[] = raw.map((n: any) => ({
          id: String(n.id_nivel),
          nombre: String(n.name),
        }));

        setData(niveles);
      } catch (error) {
        console.error("Error consultando niveles TP:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNiveles();
  }, [especialidadId]); 

  const handleChange = (event: SelectChangeEvent<string>) => {
  const selectedId = event.target.value;
  if (!selectedId) return;

  const nivelSeleccionado = data.find((x) => x.id === selectedId);
  if (nivelSeleccionado) onNivelChange(nivelSeleccionado);
};

//Para evitar el envío de id inválido
useEffect(() => {
  if (!selectedNivelId) return;
  if (data.length === 0) return;

  const exists = data.some((x) => x.id === selectedNivelId);
  if (!exists) {
    onNivelChange({ id: "", nombre: "" } as any);
  }
}, [data, selectedNivelId, onNivelChange]);


  return (
    <Grid item xs={12}>
      <Box>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          Nivel TP *
        </Typography>

        <FormControl fullWidth>
          <Select
            labelId="select-nivel-tp"
            id="select-nivel-tp"
            variant="outlined"
            value={selectedNivelId || ""}
            displayEmpty
            onChange={handleChange}
            //disabled={disabled || loading || !especialidadId}
            renderValue={(value) => {
              if (!especialidadId) return "Selecciona primero una especialidad";
              if (!value) return "Selecciona por ejemplo: III° Medio TP";
              const found = data.find((x) => x.id === value);
              return found?.nombre ?? "Nivel TP";
            }}
            sx={{
              fontFamily: "montserrat",
              fontSize: "14px",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": { borderRadius: 2 },
              "& fieldset": { borderColor: "#BDBDBD" },
              "&:hover fieldset": { borderColor: "#9E9E9E" },
              "&.Mui-focused fieldset": { borderColor: "#005559" },
              "& .MuiSelect-select": {
                color: selectedNivelId ? "#005559" : "#B3D1D1",
              },
            }}
          >
            

            {loading && (
              <MenuItem value="" disabled>
                <Box display="flex" alignItems="center" gap={1}>
                  <SpinnerUmmIA logoWidth={20} logoHeight = {20}/>
                  Cargando...
                </Box>
              </MenuItem>
            )}

            {data.map((nivel) => (
              <MenuItem key={nivel.id} value={nivel.id} sx={{ color: "#005559" }}>
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  {nivel.nombre}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
};

export default GetNivelesTP;
